import { isUndefined } from 'lodash';

import fetch from 'utilities/fetch';
import { paths } from 'config/path_helpers';

export const analyticsSaveRecentFilters = async (filters) => {
  fetch(paths.api.statisticRecentFilters(), {
    method: 'POST',
    body: JSON.stringify({ filters })
  });
};

export const fetchGradingRequestsStatus = (ids: number[]) => {
  return fetch(paths.api.aiGradingRequestsStatus(ids)).then((response) => {
    return response.gradingRequests;
  });
};

export const fetchMockTestsGradingRequestsStatus = (mockTestId) => {
  return fetch(paths.api.mockTestGradingRequestsStatus(mockTestId)).then((response) => {
    return response.gradingRequests;
  });
};

export const fetchAnswers = (filters, page) => {
  return fetch(paths.api.answers(filters, page)).then((response) => {
    return response.answers;
  });
}

export const fetchAnswersSummary = (filters) => {
  return fetch(paths.api.answersSummary(filters)).then((response) => {
    return response.answers.summary;
  });
}

export const fetchPage = (path) => {
  const url = new URL(path, window.location.origin);
  const params = url.search;
  const jsonPath = `${url.pathname}.json${params}`;

  return fetch(jsonPath).then((response) => {
    return response;
  });
};

export const fetchStatistic = (name, filters) => {
  return fetch(paths.api.statistic(name, filters)).then((response) => {
    return response.statistic;
  });
};

export const fetchUserProfile = () => {
  return fetch(paths.api.userProfile()).then((response) => {
    return response.userProfile;
  });
};

export const regradeMockTestsGradingRequests = (mockTestId) => {
  return fetch(paths.api.mockTestGradingRequestsRegrade(mockTestId), {
    method: 'POST'
  }).then((response) => {
    return response.gradingRequests;
  });;
};

export const updateUserProfile = (userProfile) => {
  return fetch(paths.api.userProfile(), {
    method: 'PUT',
    body: JSON.stringify({ userProfile })
  }).then((response) => {
    return response.userProfile;
  });
};
